import { Menu } from "../utils/types/navigation.type";
import { ApiClient, ClientType } from "./apiClient/ApiClient";
import { ServiceType } from "./apiClient/config";

const apiClient = () => {
  return ApiClient.Client(ClientType.NotCached, ServiceType.Apiv2);
};

export const getSideNavs = async () => await apiClient().get<Menu[]>("portal-frame/sidenavs");
